var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalonLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9959 12.6022C14.125 12.6022 12.603 14.1241 12.603 15.997C12.603 17.8679 14.125 19.3879 15.9959 19.3879C17.8668 19.3879 19.3888 17.8679 19.3888 15.997C19.3888 14.1241 17.8668 12.6022 15.9959 12.6022M15.9959 22.296C12.5216 22.296 9.69482 19.4712 9.69482 15.9969C9.69482 12.5206 12.5216 9.69391 15.9959 9.69391C19.4702 9.69391 22.2969 12.5206 22.2969 15.9969C22.2969 19.4712 19.4702 22.296 15.9959 22.296",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1388_16",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H31.9889V37.8062H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1388_16)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.994 2.90822C8.77785 2.90822 2.90722 8.83508 2.90722 16.1171C2.90722 25.3826 13.8109 34.4095 15.994 34.8903C18.1771 34.4076 29.0808 25.3806 29.0808 16.1171C29.0808 8.83508 23.2101 2.90822 15.994 2.90822V2.90822ZM15.9944 37.8062C12.5163 37.8062 -0.000488281 27.0421 -0.000488281 16.1171C-0.000488281 7.22971 7.17494 0 15.9944 0C24.814 0 31.9894 7.22971 31.9894 16.1171C31.9894 27.0421 19.4726 37.8062 15.9944 37.8062V37.8062Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalonLoc);
export default __webpack_public_path__ + "static/media/salon-loc.fa3e8c491e2b11d2bd959c244c676dab.svg";
export { ForwardRef as ReactComponent };